import { render, staticRenderFns } from "./TraxUiModalConfirm.vue?vue&type=template&id=2b9a367a"
import script from "./TraxUiModalConfirm.vue?vue&type=script&lang=js"
export * from "./TraxUiModalConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports